import { jsx, jsxs } from 'react/jsx-runtime';
import Icon from '../Icon/Icon.js';
import { Badges, StyledPill, Container, TitleContainer, Title, Content, StyledLink } from './Card.styles.js';

/**
 *
 * Card
 *
 * This components renders the Card item in the Discover page.
 */
const Card = ({ title, content, badges, icon, url }) => {
    const renderBadges = () => (jsx(Badges, { children: badges === null || badges === void 0 ? void 0 : badges.map(badge => (jsx(StyledPill, Object.assign({ variant: "party" }, { children: badge }), badge))) }));
    const renderCard = () => (jsxs(Container, { children: [icon && jsx(Icon, { name: icon, size: "32px" }), jsxs(TitleContainer, { children: [jsx(Title, { children: title }), !!(badges === null || badges === void 0 ? void 0 : badges.length) && renderBadges()] }), jsx(Content, { children: content })] }));
    // Links are optional, cards can be just informative
    if (url) {
        return (jsx(StyledLink, Object.assign({ target: "_blank", href: url, external: true }, { children: renderCard() })));
    }
    return renderCard();
};

export { Card as default };
